module.exports = __webpack_public_path__ + "static/media/addresses.dae3d225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameMailDelivery/addresses.png
// module id = 2498
// module chunks = 0